import React from 'react';
import '../Shared.css';
import './EmptyState.css';

const EmptyState = ({ icon, title, description, action, className = '' }) => (
  <div className={`empty-state ${className}`.trim()} role="status" aria-live="polite">
    {icon ? <div className="empty-state-icon" aria-hidden="true">{icon}</div> : null}
    {title ? <h3 className="empty-state-title">{title}</h3> : null}
    {description ? <p className="empty-state-description">{description}</p> : null}
    {action?.label && typeof action.onClick === 'function' ? (
      <button type="button" className="btn primary" onClick={action.onClick}>
        {action.label}
      </button>
    ) : null}
  </div>
);

export default EmptyState;
